import { createContext } from 'react';

import Device from '~interfaces/device';

export interface SelectedDevicesContextValue {
	singleDevice: Device | undefined;
	selectedDevices: Device[];
	updateSingleDevice: (device: Device | undefined) => void;
	addDevice: (device: Device) => void;
	removeDevice: (device: Device) => void;
	replaceSelectedDevices: (devices: Device[]) => void;
}

const SelectedDevicesContext = createContext<SelectedDevicesContextValue>({
	singleDevice: undefined,
	selectedDevices: [],
	updateSingleDevice: () => {},
	addDevice: () => {},
	removeDevice: () => {},
	replaceSelectedDevices: () => {},
});

export default SelectedDevicesContext;
